<template>
  <v-container class="py-8 bg-light-blue-main">
    <div style="display: grid; grid-template-columns: 2fr 1fr">
      <div>
        <h1>{{ $t("views.main.user-spaces") }}</h1>
        <div class="d-flex flex-row ga-8 flex-wrap">
          <div
            v-for="space in privateSpaces"
            :key="space.id">
            <SpaceCard
              :space="space"
              @edit-space="() => editSpace(space.id)"></SpaceCard>
          </div>

          <div>
            <v-card @click="spaceCreateDialog = true">
              <v-card-title>{{ $t("views.main.new-space") }}</v-card-title>
              <v-card-subtitle></v-card-subtitle>
            </v-card>
          </div>
        </div>

        <template v-if="teamSpaces.length > 0"
          ><h1>{{ $t("views.main.team-spaces") }}</h1>
          <div class="d-flex flex-row ga-8 flex-wrap">
            <div
              v-for="space in teamSpaces"
              :key="space.id">
              <SpaceCard
                :space="space"
                @edit-space="() => editSpace(space.id)"></SpaceCard>
            </div></div
        ></template>
      </div>
      <div>
      <h1>Videos & Hilfe</h1>
      <div class="d-flex flex-row ga-8 flex-wrap">
        <div
          v-for="video in videos"
          :key="video.name" style="border: 1px grey solid; border-radius: 5px; padding: 10px;">

          <video
            controls
            width="600">
            <source
              :src="video.src"
              type="video/mp4" />
          </video>
          <h4>{{ video.name }}</h4>
        </div></div>
      </div>
    </div>
    <v-dialog v-model="spaceEditDialog">
      <SpaceEdit
        :space-id="spaceEditId"
        @close="spaceEditDialog = false" />
    </v-dialog>

    <v-dialog v-model="spaceCreateDialog">
      <SpaceCreate @close="spaceCreateDialog = false" />
    </v-dialog>
  </v-container>
</template>

<script lang="ts" setup>
import { useMainStore } from "@/stores/mainStore";
import { computed, onMounted, Ref, ref } from "vue";
import SpaceEdit from "@/components/dialogs/SpaceEdit.vue";
import SpaceCreate from "@/components/dialogs/SpaceCreate.vue";
import SpaceCard from "./Space/SpaceCard.vue";
import axios from "axios";

const mainStore = useMainStore();

const spaceEditDialog = ref(false);
const spaceEditId = ref(null);
const spaceCreateDialog = ref(false);

const videos: Ref<{ name: string; src: string }[]> = ref([]);

const privateSpaces = computed(() => {
  return mainStore.calculationSpaces.filter((space) => !space.organization);
});

const teamSpaces = computed(() => {
  return mainStore.calculationSpaces.filter((space) => space.organization);
});

onMounted(() => {
  axios.get("/api/video").then((response) => {
    videos.value = response.data.map((video: string) => ({
      name: video.split(".mp4")[0],
      src: axios.defaults.baseURL + "/api/video/" + video
    }));
  });
});

const editSpace = (spaceId: number) => {
  spaceEditId.value = spaceId;
  spaceEditDialog.value = true;
};
</script>

<style scoped lang="scss">
.v-card {
  width: 400px;
  height: 400px;
}
</style>
